module.exports = __webpack_public_path__ + "static/dany_cut-19d4a1a4456d98cf4c75d9019a78bfdd.png";